import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { TransactionStatus } from '../service-proxies';


export class ClarificationDto implements IClarificationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    approver!: EmployeeSummaryDto;
    clarificationDate!: Date;
    clarificationTime!: Date;
    clarificationRequestDate!: Date;
    reason!: string | undefined;
    status!: TransactionStatus;

    constructor(data?: IClarificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.clarificationDate = _data["clarificationDate"] ? new Date(_data["clarificationDate"].toString()) : <any>undefined;
            this.clarificationTime = _data["clarificationTime"] ? new Date(_data["clarificationTime"].toString()) : <any>undefined;
            this.clarificationRequestDate = _data["clarificationRequestDate"] ? new Date(_data["clarificationRequestDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ClarificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClarificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["clarificationDate"] = this.clarificationDate ? this.clarificationDate.toISOString() : <any>undefined;
        data["clarificationTime"] = this.clarificationTime ? this.clarificationTime.toISOString() : <any>undefined;
        data["clarificationRequestDate"] = this.clarificationRequestDate ? this.clarificationRequestDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["status"] = this.status;
        return data; 
    }
}

export interface IClarificationDto {
    id: number;
    employee: EmployeeSummaryDto;
    approver: EmployeeSummaryDto;
    clarificationDate: Date;
    clarificationTime: Date;
    clarificationRequestDate: Date;
    reason: string | undefined;
    status: TransactionStatus;
}

